import { useTranslations } from "@/lib/useTranslations";
import { EditorialChecklistItems } from "@/components/ui/admin/EditorialChecklistItems";
import type { ArticleEditorialChecklistState } from "@/core/services/types/article.types";

type ArticleEditorialChecklistItemsProps = {
  checklist: ArticleEditorialChecklistState;
  showLabel?: boolean;
  className?: string;
};

export function ArticleEditorialChecklistItems({
  checklist,
  showLabel = true,
  className = "space-y-2",
}: ArticleEditorialChecklistItemsProps) {
  const t = useTranslations("articles.edit");
  const { hasCoverImage, hasTitle, hasSubTitle, hasContent } = checklist;

  return (
    <EditorialChecklistItems
      showLabel={showLabel}
      label={t("checklistLabel")}
      className={className}
      items={[
        { checked: hasCoverImage, label: t("checklistImage") },
        { checked: hasTitle, label: t("checklistTitle") },
        { checked: hasSubTitle, label: t("checklistSubTitle") },
        { checked: hasContent, label: t("checklistContent") },
      ]}
    />
  );
}
